import { Upload, message, Spin } from "antd";
import { DeleteOutlined, LoadingOutlined } from "@ant-design/icons";
import Cookies from "js-cookie";
import axios from "axios";
import { useState , useEffect } from "react";
import React from "react";
import './UploadFile.css';
import { GetActiveListLastUploadedDate } from "../../Repository/HealthInsuranceRepository";
import moment from 'moment-timezone';
const Uploadfile = () => {
  const jwtToken = Cookies.get("jwt_token");
  const userLogin = Cookies.get("UserLogin");
  const [fileList, setFileList] = useState([]);
  const [loadingFileName, setLoadingFileName] = useState('')
  const [manualLoadingFileName, setManualLoadingFileName] = useState('');
  const [spinLoader, setSpinLoader] = useState(false);
  const [uploadSpinLoader, setUploadSpinLoader] = useState(false)
  const [paychexFileList, setPaychexFileList] = useState([]);
  const [dateList, setDateList] = useState(null);
  
  const antIcon = (
    <LoadingOutlined
      style={{
        fontSize: 30,
        color: '#003A8C'
      }}
      spin
    />
  );

 

  const uploadFile = (options) => {

                                    

    try{
      setUploadSpinLoader(true)
      const { file, onSuccess, onError } = options;
      const updatedFile = { file, status: "uploading" }
      const formData = new FormData();
      formData.append("file", file);
      setManualLoadingFileName(file.name);
      axios
        .post(
          `${process.env.REACT_APP_BASE_URL}Home/manualuploadFile?userLogin=` +
          userLogin,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              "Access-Control-Allow-Origin": "no-cors",
              Authorization: `Bearer ${jwtToken}`,
            },
          }
        )
        .then((response) => {
          if (response.data.IsSuccess === true) {
            onSuccess(file);
            message.success(`${file.name} file uploaded successfully.`);
            updatedFile.status = "done";
            setFileList([updatedFile])
            setUploadSpinLoader(false)
            setManualLoadingFileName('')
          } else {
            onError(file);
            if(response.data.Message === "FileName is Invalid")
            {message.error(`${file.name} file name is invalid`);}
            else{message.error(`${file.name} file upload failed`);}
            updatedFile.status = "error";
            setFileList([updatedFile]);
            setUploadSpinLoader(false)
            setManualLoadingFileName('')
          }
        })
        .catch((error) => {
          // console.log(error.message);
          setUploadSpinLoader(false)
          setManualLoadingFileName('')
        });
    }
    catch{
      setUploadSpinLoader(false)
      setManualLoadingFileName('')
    }
  };

   //getting the latest paychex uploaded Date
   useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    try{
      const response=await GetActiveListLastUploadedDate();
      console.log(response);
      if(response && response.payload){
        const payloadObject = JSON.parse(response.payload);
        setDateList(payloadObject);
        console.log(payloadObject);
      }
    }catch(err){
      console.log(err);
    }
  };



  const paychexuploadFile = async (options) => {
    try {
      setSpinLoader(true)
      const { file, onSuccess, onError } = options;
      const updatedPaychexFile = { file, status: "uploading" }
      const formData = new FormData();
      formData.append("file", file);
      setLoadingFileName(file.name)
      axios
        .post(
          `${process.env.REACT_APP_BASE_URL}Paychex/manualuploadFilePaychex`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              "Access-Control-Allow-Origin": "no-cors",
              Authorization: `Bearer ${jwtToken}`,
            },
          }
        )
        .then((response) => {
          if (response.data.IsSuccess === true) {
            onSuccess(file);
            fetchData();
            message.success(`${file.name} file uploaded successfully.`);
            updatedPaychexFile.status = "done";
            setPaychexFileList([updatedPaychexFile])
            setSpinLoader(false)
            setLoadingFileName('')
          }
          else {
            onError(file);
            message.error(`${file.name} file upload failed.`);
            updatedPaychexFile.status = "error";
            setPaychexFileList([updatedPaychexFile])
            setSpinLoader(false)
            setLoadingFileName('')
          }
        })
        .catch((error) => {
          // console.log(error.message);
          setSpinLoader(false)
          setLoadingFileName('')
        });
    }
    catch {
      setSpinLoader(false)
      setLoadingFileName('')
    }
  };

  const itemRender = (originNode, file) => {
    let statusColor;
    if (file.status === "done") {
      statusColor = "green";
    } else if (file.status === "error") {
      statusColor = "#f55451";
    }
    let fileExists = false;
    if (fileList.length > 0) {
      fileExists = true;
    }
    return <>
      <div style={{ color: statusColor, width: "100%", display: "flex", justifyContent: "space-between", backgroundColor: "#f2f8fc", marginTop: "2px", borderRadius: "4px" }}>{fileExists ? fileList[0].file.name : null}<DeleteOutlined onClick={() => setFileList([])} /></div>
    </>;
  };

  const itemRenderPaychex = (originNode, file) => {
    let statusColor;
    if (file.status === "done") {
      statusColor = "green";
    } else if (file.status === "error") {
      statusColor = "#f55451";
    }
    let fileExists = false;
    if (paychexFileList.length > 0) {
      fileExists = true;
    }
    return <div style={{ color: statusColor, width: "100%", display: "flex", justifyContent: "space-between", backgroundColor: "#f2f8fc", marginTop: "2px", borderRadius: "4px" }}>{fileExists ? paychexFileList[0].file.name : null}<DeleteOutlined onClick={() => setPaychexFileList([])} /></div>;
  };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        width: "100%",
        // marginLeft:"50px",
      }}
    >
      <div className="spinner-upload">
        <div
          style={{
            height: "40px",
            width: "70%",
            border: "1px dashed #003A8C",
            borderRadius: "10px",
          }}
        >
          <Upload.Dragger
            name="file"
            customRequest={uploadFile}
            itemRender={itemRender}
            fileList={fileList}
            onRemove={() => setFileList([])}
          >
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "center" }}>
              <img src="./Images/UploadIcon.png" style={{ height: "35px" }}></img>
              <div>
                <span
                  style={{ color: "rgba(0, 58, 140, 0.5)", fontSize: "24px" }}
                >
                  Manual Upload
                </span>
              </div>
            </div>
          </Upload.Dragger>
          {
            manualLoadingFileName.length !== 0 && <div>{manualLoadingFileName}</div>
          }
          <label
            style={{ marginTop: "10px", fontSize: "11.3px", color: "#096DD9" }}
          >
            Note: Filename should be "VMSName_ClientName" format{" "}
          </label>
        </div>
        {uploadSpinLoader && 
          <div className="paychex-manual-spinner">
          <Spin indicator={antIcon} />
        </div>}
      </div>
      <div className="spinner-upload">
        <div
          style={{
            height: "40px",
            width: "70%",
            border: "1px dashed #003A8C",
            borderRadius: "10px",
          }}
        >
          <Upload.Dragger
            name="file"
            customRequest={paychexuploadFile}
            itemRender={itemRenderPaychex}
            fileList={paychexFileList}
            onRemove={() => setPaychexFileList([])}
          >
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "center" }}>
              <img src="./Images/UploadIcon.png" style={{ height: "35px" }}></img>
              <span
                style={{
                  color: "rgba(0, 58, 140, 0.5)",
                  fontSize: "24px",
                }}
              >
                Active List  Upload
              </span>
            </div>
          </Upload.Dragger>
          

          {
        loadingFileName.length !== 0 && <div>{loadingFileName}</div>
      }
          <label
            style={{ marginTop: "5px",marginBottom:"0", fontSize: "11.3px", color: "#096DD9" }}
          >
            Note: It will take some time to upload, please wait.
          </label>
          <p style={{marginBottom:"-1px",marginTop:"0"}}> 
            Last Uploaded Date:{" "}
            {dateList &&
              dateList.paychexDate&&
              moment.utc(dateList.paychexDate).tz('Asia/Kolkata').format(
                "MM/DD/YYYY HH:mm:ss"
              )}
          </p>
        </div>
        {spinLoader &&
          <div className="paychex-manual-spinner">
            <Spin indicator={antIcon} />
          </div>}
      </div>
    </div>
  );
};

export default Uploadfile;
